import React from 'react';
import { Box } from '@zillow/constellation-10';

// Styles
import { containerStyles, dotRecipe } from './styles';

// Types
type DotsPropTypes = {
  index: number;
  count: number;
  onGoToItem: (index: number) => void;
};

const Dots = ({ index, count, onGoToItem }: DotsPropTypes) => {
  const dots = [];
  for (let i = 0; i < count; i++) {
    dots.push(
      <Box
        key={i}
        css={dotRecipe.raw({ isActive: i === index })}
        onClick={() => onGoToItem(i)}
        role="button"
        onKeyDown={(e) => e.key === 'Enter' || (e.key === 'Space' && onGoToItem(i))}
      />,
    );
  }

  return <Box css={containerStyles}>{dots}</Box>;
};

export default Dots;
